import React from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import ChecklistTemplateTable from "./ChecklistTemplateTable";
import ClientChecklistTemplateTable from "./ClientChecklistTemplateTable";
import { UserTypes } from "../../enum/UserTypes";

export default function ChecklistTemplateTableView(props: RouteComponentProps) {
  // Only use ClientChecklistTemplateTable if the user's active_type is actually Client
  // Don't rely on URL path as admins might access through client routes
  const isClientUser = props.session?.active_type === UserTypes.Client;

  // Use different Panels based on user type only
  if (isClientUser) {
    return <ClientChecklistTemplateTable props={props} />;
  }

  return <ChecklistTemplateTable props={props} />;
}
